import { extendableOfferButton } from '@molecules/components/extendable-offer-button';
import { flashBagSuccess } from '@tools/flashbag';
import { translations } from '@tools/translations/translations';

const addCopyLinkEventListener = (HTMLElement, parent) => {
  HTMLElement?.addEventListener('click', () => {
    navigator.clipboard.writeText(HTMLElement.dataset.url).then(() => {
      flashBagSuccess(translations.messages['offer.link.copied']);
      parent.classList.remove('active');
    });
  });
};

const addShareEmailEventListener = (HTMLElement, parent) => {
  HTMLElement?.addEventListener('click', () => {
    const email = '';
    const subject = '';
    const body = HTMLElement.dataset.url;
    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    parent.classList.remove('active');
    window.open(mailtoLink, '_blank');
  });
};

export const share = () => {
  document.querySelectorAll('[data-share]').forEach((shareButton) => {
    shareButton.addEventListener('click', () => {
      if (window.BREAKPOINTS.isTabletLarge || window.BREAKPOINTS.isDesktop || !window.navigator.share) {
        const modalId = shareButton.dataset.modal;
        const shareModal = document.getElementById(modalId);
        addCopyLinkEventListener(document.getElementById(`${modalId}-copy-link-button`), shareModal);
        addShareEmailEventListener(document.getElementById(`${modalId}-share-email-button`), shareModal);
        shareModal.classList.toggle('active');
        return;
      }

      navigator.share({
        title: '',
        text: '',
        url: shareButton.dataset.url,
      })
        .then(() => {
          flashBagSuccess(translations.messages['offer.shared']);
        })
        .catch(() => {
        }); // Generate an error when we cancel share, we ignore it
    });
  });

  // Share button with copy to clipboard feature
  const shareButtonContainer = document.querySelector('.offer-details [data-share-button="on"]');
  if (shareButtonContainer) {
    extendableOfferButton(shareButtonContainer);
  }
};
